module.exports = __webpack_public_path__ + "img/kak-img-mob.ab23678b.png";